import { Link } from "react-router-dom";
import { Stack } from "../../../shared/ui/Stack/Stack";
import { Text } from "../../../shared/ui/Text/Text";
import styles from './Welcome.module.scss';
import { getRouteMyWorks } from "../../../app/providers/router/config/helpers";


const Welcome = () => {
    return (  
        <Stack
            direction='column'
            justifyContent = 'justifyCenter'
            alignItems='alignCenter'
            gap= '16'
            className = {styles.container}
        >
            <Text type='h4' size="l" className = {styles.title}>
                Добро пожаловать
            </Text>
            <div className={styles.text__content}>
            <Text type='h1' size="l" className={styles.text}>
                Ваш семейный фотограф в Подольске и Москве
            </Text>
            <Text type='h1' size="l" className={styles.text}>
                Елена Ковешникова
            </Text>
            </div>

                <Link to={getRouteMyWorks()} className={styles.portfolio}>
                    Портфолио
                </Link>

        </Stack>
    );
}
 
export default Welcome;